import {
  Component,
  ChangeDetectorRef,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ViewEncapsulation,
} from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { PanelsInterfaceComponent } from '../panels-interface.component';
import { Project } from 'app/modules/projects/projects.types';
import { ProjectsService } from 'app/modules/projects/projects.service';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';

@Component({
  selector: 'project-panel-nearby',
  templateUrl: './nearby.component.html',
  styleUrls: ['./nearby.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelsNearbyComponent extends OnDestroyMixin implements PanelsInterfaceComponent, OnInit {
  @Input() project: any;
  @Input() account: any;
  @Input() panelDef: any;
  @Input() data: any;
  @Input() canEditPanelDef = true;
  @Output() onUpdate: EventEmitter<string> = new EventEmitter();
  @Output() onEditPanelDef: EventEmitter<any> = new EventEmitter();

  displayColumns: string[];
  nearbyProjects$: Observable<Project[]>;
  loading: boolean = false;

  /**
   * Constructor
   */
  constructor(private _projectsService: ProjectsService, private _changeDetectorRef: ChangeDetectorRef) {
    super();
    this.displayColumns = ['title', 'address'];
  }

  ngOnInit() {
    this._projectsService.project$.pipe(untilComponentDestroyed(this)).subscribe((project: Project) => {
      this.project = project;
      this._changeDetectorRef.markForCheck();
    });

    this.nearbyProjects$ = this._projectsService.getNearbyProjects(this.project.id).pipe(
      untilComponentDestroyed(this),
      tap(() => (this.loading = false)),
    );
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
}
